import { render, staticRenderFns } from "./TabelaMinuta.vue?vue&type=template&id=f0e76ae4&scoped=true&"
import script from "./TabelaMinuta.vue?vue&type=script&lang=js&"
export * from "./TabelaMinuta.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMinuta.vue?vue&type=style&index=0&id=f0e76ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e76ae4",
  null
  
)

export default component.exports